/* PIKOVA — the gate.

   The front door, and the whole of it. Whoever arrives at the homepage meets
   the film first; nothing scrolls, nothing else is reachable, and the only way
   in is the button. Press it and the curtain lifts, the site arrives behind it,
   and from then on the visit is ordinary.

   Shown once per browser tab. After ENTER is pressed, the press is kept in
   sessionStorage and the gate section removes itself on later homepage loads
   in the same tab, before this script runs. A new tab or a new visit meets the
   gate again.

   It guards the homepage only. Someone following an advertisement to a plan, or
   a search result to The Source, gets the page they asked for. */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pkReady === 'true') return;
    root.dataset.pkReady = 'true';

    var enter = root.querySelector('[data-pk-enter]');
    var body = document.body;

    var film = root.querySelector('[data-pk-film]');

    if (film) {
      var nudge = function () {
        var playing = film.play();
        if (playing && playing.catch) playing.catch(function () {});
      };

      // Which cut the screen gets. The element arrives with no src, so nothing
      // is fetched until this runs and exactly one film is ever downloaded.
      var narrow = matchMedia('(max-width: 749px)');

      var choose = function () {
        // once the gate has lifted, its film is finished with for good
        if (film.dataset.pkDone) return;

        var wanted = narrow.matches ? film.dataset.tall : film.dataset.wide;
        var poster = narrow.matches
          ? film.dataset.posterTall
          : film.dataset.posterWide;

        if (poster) film.poster = poster;
        if (!wanted || film.getAttribute('src') === wanted) return;

        film.setAttribute('src', wanted);
        film.load();
        nudge();
      };

      choose();

      // A phone turned on its side crosses the breakpoint and wants the wide
      // cut. Only a crossing fires this, so an ordinary window drag does not
      // restart the film under someone.
      if (narrow.addEventListener) narrow.addEventListener('change', choose);
      else if (narrow.addListener) narrow.addListener(choose);

      // A muted film may autoplay, but a tab restored from the background often
      // comes back paused. One nudge when it is ready, one when the page is
      // looked at again. If the browser still refuses, the poster is a good
      // picture and nothing looks broken.
      if (film.readyState >= 2) nudge();
      film.addEventListener('canplay', nudge, { once: true });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && film.paused && !film.dataset.pkDone) nudge();
      });
    }

    if (root.dataset.hold !== 'true') return;

    // everything that is not the gate waits behind it, and out of reach
    var behind = [].slice.call(
      document.querySelectorAll(
        '#MainContent > .shopify-section:not(.pk-gate-section),' +
          '.shopify-section-group-header-group,' +
          '.shopify-section-group-footer-group'
      )
    );

    function setInert(state) {
      behind.forEach(function (el) {
        if (state) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    body.classList.add('pk-gated');
    setInert(true);

    var block = function (e) {
      if (body.classList.contains('pk-gated')) e.preventDefault();
    };
    addEventListener('touchmove', block, { passive: false });
    addEventListener('wheel', block, { passive: false });

    var opened = false;

    function open() {
      if (opened) return;
      opened = true;
      // Remember the press for this tab, so the Home link does not lock the page again
      try { sessionStorage.setItem('pk_gate_passed', '1'); } catch (e) {}

      root.classList.add('pk-lifting');
      body.classList.remove('pk-gated');
      body.classList.add('pk-opening');
      setInert(false);

      // the lock has just come off, and the page should begin at its beginning
      scrollTo(0, 0);

      // Once it has gone, it is gone: taken out of the layout so the homepage
      // starts at its first real section and scrolling back up does not find
      // the film again.
      setTimeout(function () {
        root.style.display = 'none';
        body.classList.remove('pk-opening');

        // Hidden is not stopped: unload the film so it stops playing, decoding
        // and holding memory behind the homepage for the rest of the visit.
        if (film) {
          film.dataset.pkDone = 'true';
          film.pause();
          film.removeAttribute('src');
          film.load();
        }
      }, 950);

      // the first thing behind the curtain should be where a keyboard lands
      var first = document.querySelector('#MainContent h1, #MainContent h2');
      if (first) {
        first.setAttribute('tabindex', '-1');
        setTimeout(function () {
          first.focus({ preventScroll: true });
        }, 500);
      }
    }

    if (enter) {
      enter.addEventListener('click', function () {
        open();
      });
    }

    addEventListener('keydown', function (e) {
      if (!body.classList.contains('pk-gated')) return;
      if (
        e.key === 'Enter' ||
        e.key === ' ' ||
        e.key === 'ArrowDown' ||
        e.key === 'Escape'
      ) {
        e.preventDefault();
        open();
      }
    });

    // a page restored from the back/forward cache must never come back locked
    addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      body.classList.remove('pk-gated');
      setInert(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-pk-gate]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // the theme editor adds, removes and reloads sections underneath us, and an
  // editor that cannot be scrolled is an editor that cannot be used
  document.addEventListener('shopify:section:load', function (e) {
    document.body.classList.remove('pk-gated');
    var gate = e.target.querySelector('[data-pk-gate]');
    if (gate) init(gate);
  });

  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('pk-gated');
  });
})();